import {
    GET_ALL_COMMENTS_REQUEST,
    GET_ALL_COMMENTS_SUCCESS,
    GET_ALL_COMMENTS_FAIL,

} from '../constants/commentConstants'
import axios from 'axios'

export const getAllComments = () => async(dispatch) => {
    try {
        dispatch({
            type: GET_ALL_COMMENTS_REQUEST
        })

        const { data } = await axios.get(process.env.REACT_APP_GOLANGAPI + '/api/comments')

        dispatch({
            type: GET_ALL_COMMENTS_SUCCESS,
            payload: data,
        })
    }
    catch(error){
        dispatch({
            type: GET_ALL_COMMENTS_FAIL,
            payload: error.response && error.response.data
            ? error.response.data
            : error.message,
        })
    }
}